import  { useState   } from "react";

import {Drawer ,message, Button,BackTop,Modal,Form,Input} from 'antd'
import ApiService from '../../utils/axios';


export default function MyRightDrawer (props){
  const [loading, setloading] = useState(true);
  //


  const onFinish = (fieldsValue) => {
    const data = {
      skuIds:fieldsValue.skuIds
    }

    setloading(true)
 


    ApiService.post('/dewu/sku/querybyspuId',data
    ).then(res => { 
      setloading(false)
    })

  }

  const onClose = () => {
    props.setOpen(false);
  };




    return(
      <Drawer title="读取得物sku" placement="right" onClose={onClose} open={props.open}>
        <Form  onFinish={onFinish}   autoComplete="off">
              <Form.Item
              name="skuIds"
                label="skuIds">
                <Input ></Input>
              </Form.Item>
              <Form.Item 
                      wrapperCol={{
                        xs: { span: 24, offset: 0 },
                        sm: { span: 16, offset: 16 },
                      }}>
              <Button type="primary" htmlType="submit" >
          提交
        </Button>
        </Form.Item>
              </Form>
    </Drawer>
    )
}